import { createProfileField } from "@/shared/api/profilebuilder"
import notify from "@/shared/lib/notify"
import { FC, useState } from "react"

interface AddFormfieldProps {
    update: () => void
    formId: string
    index: number
}

export const AddFormfield: FC<AddFormfieldProps> = ({ formId, update, index }) => {
    const [isLoading, setIsLoading] = useState<boolean>(false)

    const handleAdd = async () => {
        setIsLoading(true)
        await createProfileField({
            type: "string",
            title: "Новое поле",
            editable: true,
            required: false,
            place_number: index,
            validation_rules: {
                min_length: 0,
                max_length: 255,
                regexp: ''
            },
            profile_template_id: formId
        })
        .then(() => {
            update()
        })
        .catch(() => {
            notify.error('Не удалось добавить поле')
        })
        .finally(() => {
            setIsLoading(false)
        })
    }

    return (
        <button disabled={isLoading} onClick={handleAdd} className="form_handle_button">
            Добавить поле
        </button>
    )
}